  <template>
  <div>
<!--    <div class="a-container-form contractor__block">-->
<!--      <div class="a-label">{{$t('form.contractor.status')}}:</div>-->
<!--      <p class="a-input a-input&#45;&#45;disabled">Зарегистрирован</p>-->
<!--    </div>-->
    <div class="a-container-form contractor__block">
      <div class="a-label">{{$t('form.contractor.type-of-organization')}}:</div>
      <p class="a-input a-input--disabled" v-t="org.type.label"></p>
    </div>
    <div class="a-container-form contractor__block ">
      <div class="a-label ">{{$t('form.contractor.person-status')}}:</div>
      <p class="a-input a-input--disabled" v-t="'person-status.' + org.resident"></p>
    </div>
    <div class="a-container-form contractor__block">
      <div class="a-label ">{{$t('form.contractor.full-title')}}:</div>
      <p class="a-input a-input--disabled ">{{org.fullName}}</p>
    </div>
    <div class="a-container-form contractor__block" v-if="currentUser.permissions.CAN_VIEW_ADMIN">
      <div class="a-label ">{{$t('form.contractor.short-title')}}:</div>
      <div class="a-form-field" v-if="isEditing">
        <input type="text" class="a-input contractor__name-contractorm a-input--w-380" :placeholder="$t('form.contractor.short-title')" v-model.trim="shortName">
      </div>
      <p class="a-input a-input--disabled " v-else>{{org.shortName | defaultValue($t('labels.short-name-not-specified'))}}</p>
    </div>
    <div class="a-container-form contractor__block">
      <div class="a-label ">{{$t('labels.inn-long')}}:</div>
      <p class="a-input a-input--disabled ">{{org.inn}}</p>
    </div>
    <div class="a-container-form contractor__block" v-if="org.boss">
      <div class="a-label">{{$t('form.contractor.chief')}}:</div>
      <p class="a-input a-input--disabled ">{{org.boss.lastName}} {{org.boss.firstName}} {{org.boss.middleName}}</p>
    </div>
    <div class="a-container-form contractor__block" v-if="org.accountant">
      <div class="a-label">{{$t('form.contractor.chief-accountant')}}:</div>
      <p class="a-input a-input--disabled ">{{org.accountant.lastName}} {{org.accountant.firstName}} {{org.accountant.middleName}}</p>
    </div>
    <div class="a-checkbox">
      <label class="a-checkbox__label">
        <input class="a-checkbox__input"
               type="checkbox"
               v-model="org.accountant.accountantOut"
               disabled>
        <span class="a-checkbox__icon"></span>
        <span class="a-checkbox__text">
          Бухгалтерия на аутсорсинге
        </span>
      </label>
    </div>
    <div class="personal-data__btn-block contractor__btn-block">
      <button class="gui-btn gui-btn--red gui-btn--w-140" v-t="'buttons.modify'" v-if="!isEditing && currentUser.permissions.CAN_ADMIN_EDIT_ORG" @click.prevent="onModifyClick"></button>
      <template v-else>
        <button class="gui-btn gui-btn--red gui-btn--w-140" v-t="'buttons.cancel'" @click.prevent="onCancelClick"></button>
        <button class="gui-btn gui-btn--red gui-btn--w-140" v-t="'buttons.save'" @click.prevent="onSaveClick"></button>
      </template>
    </div>
    <contractor-user-list :profile="profile" :organization="organization"></contractor-user-list>
  </div>
</template>

<script>
  import ContractorUserList from './ContractorUsersList';

  export default {
    name: "ContractorViewMode",

    components: {
      ContractorUserList
    },

    props: {
      profile: Object,
      organization: Object,
    },

    data: () => ({
      isEditing: false,
      shortName: undefined
    }),

    computed: {
      user() { return this.profile },
      org() { return this.organization },
      permissions() { return this.user.permissions }
    },

    methods: {
      onModifyClick() {
        this.shortName = this.org.shortName;
        this.isEditing = true;
      },

      onCancelClick() {
        this.shortName = undefined;
        this.isEditing = false;
      },

      onSaveClick() {
        this.runAction(async () => {
          try {
            await this.$store.dispatch('updateOrgByAdmin', { userId: this.org.id, shortName: this.shortName });
            this.onCancelClick();
          }
          catch(e) {
            console.error('unable to save changes in contractor', e);
            this.globalErrorHandler(e);
          }
        });
      }
    }
  }
</script>

<style scoped>

</style>
